import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import BlogCards from "./components/BlogCards/BlogCards";
import BlogView from "./components/BlogView/BlogView";
import "./App.scss";
import ContactUs from "./components/ContactUs/ContactUs";
import Footer from "./components/Footer/Footer";
import { useDispatch } from "react-redux";
import { loadData, loadImages } from "./actions";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./store";
import About from "./components/About/About";
import { initializeAnalytics, logPageView } from "./analytics";
import Loader from "./components/Loader/Loader";
import BreadcrumbSchema from "./components/BreadcrumbSchema/BreadcrumbSchema";

const App = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    initializeAnalytics();
    logPageView();
  }, []);

  useEffect(() => {
    const importAll = (requireContext) =>
      requireContext.keys().map(requireContext);

    const jsonFiles = importAll(
      require.context("./assets/data", false, /\.json$/)
    );

    const combinedData = jsonFiles.map((file) => file.default || file);

    dispatch(loadData(combinedData));

    const imageContext = require.context(
      "./assets/images",
      false,
      /\.(jpg|jpeg|png|webp)$/
    );

    const images = imageContext.keys().map((path) => {
      const filename = path.replace("./", "");
      return {
        key: filename,
        src: imageContext(path),
      };
    });
    dispatch(loadImages(images));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    return () => {
      persistor.purge();
    };
  }, []);

  return (
    <PersistGate loading={null} persistor={persistor}>
      <div className="App">
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            url: "https://tldrblogs.com",
            logo: "https://tldrblogs.com/favicon.ico",
          })}
        </script>
        <Router>
          <LoadingHandler isLoading={isLoading} setIsLoading={setIsLoading} />
          {isLoading && <Loader />}
          <Routes>
            <Route path="/about" element={<Navbar />} />
            <Route path="/blogs" element={<Navbar />} />
            <Route path="/contact-us" element={<Navbar />} />
            <Route path="/blogs/:blogPath" element={<Navbar />} />
          </Routes>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blogs" element={<BlogCards />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/blogs/:blogPath" element={<BlogView />} />
          </Routes>
        </Router>
        <Footer />
      </div>
    </PersistGate>
  );
};

// Component to handle route changes
const LoadingHandler = ({ isLoading, setIsLoading }) => {
  const location = useLocation();

  React.useEffect(() => {
    setIsLoading(true); // Start loading when location changes
    const timer = setTimeout(() => setIsLoading(false), 500); // Simulate delay for loading
    return () => clearTimeout(timer); // Cleanup the timeout
  }, [location, setIsLoading]);

  return (
    <>
      <BreadcrumbSchema /> {/* Dynamically updates breadcrumbs */}
    </>
  );
};

export default App;
